module.exports = __webpack_public_path__ + "static/media/enterBrains.22c97084.mp3";